import Component from 'D:/小小程序员/项目/medical-management/OPO-uni/node_modules/@dcloudio/uni-ui/lib/uni-file-picker/upload-file.vue'
wx.createComponent(Component)